<template>
  <div>
    <el-form :inline="true">
      <el-form-item label="释放时间：" label-width="100">
        <el-date-picker
          v-model="tTime"
          type="daterange"
          range-separator="至"
          start-placeholder="开始日期"
          end-placeholder="结束日期"
          format="yyyy年MM月dd日"
          value-format="yyyy-MM-dd HH:mm:ss"
          :default-time="['00:00:00', '23:59:59']"
        ></el-date-picker>
      </el-form-item>
      <el-form-item label="接收地址">
        <el-input
          v-model="searchForm.receivingAddress"
          placeholder="接收地址"
          clearable
        ></el-input>
      </el-form-item>
      <el-form-item label="发送地址">
        <el-input
          v-model="searchForm.sendAddress"
          placeholder="接收地址"
          clearable
        ></el-input>
      </el-form-item>
      <el-form-item label="用户姓名">
        <el-input
          v-model="searchForm.name"
          placeholder="用户姓名"
          clearable
        ></el-input>
      </el-form-item>
      <el-form-item label="手机号">
        <el-input
          v-model="searchForm.phone"
          placeholder="手机号"
          clearable
        ></el-input>
      </el-form-item>
      <el-form-item label="释放类型" label-width="100">
        <el-select v-model="searchForm.type" clearable placeholder="全部">
          <el-option label="买入" value="1"></el-option>
          <el-option label="卖出" value="2"></el-option>
        </el-select>
      </el-form-item>
      <el-form-item>
        <el-button @click="getsch" type="success">搜索</el-button>

        <!-- <el-button icon="plus" @click="exportExcel" type="primary">导出</el-button>
				        <el-upload style="display: inline-block" 
				                :action="url"
				                :on-success="handleSuccess"
				                :auto-upload="true"
				                :show-file-list="false"
				                accept=".xls, .xlsx">
				            <el-button size="small" type="danger">导入</el-button>
				        </el-upload>
				        <el-button icon="plus" @click="exporBilltExcel" type="primary">订单导出</el-button> -->
      </el-form-item>
    </el-form>
    <el-table
      ref="multipleTable"
      :data="tableData"
      tooltip-effect="dark"
      style="width: 100%"
      border
      stripe
      @selection-change="handleSelectionChange"
    >
      <el-table-column
        label="交易数量"
        align="center"
        prop="quantity"
      ></el-table-column>
      <el-table-column
        label="接收地址"
        align="center"
        prop="receivingAddress"
      ></el-table-column>
      <el-table-column
        label="发送地址"
        align="center"
        prop="sendAddress"
      ></el-table-column>

      <el-table-column
        prop="deliveryType"
        align="center"
        label="交易类型"
        width="120"
      >
        <template slot-scope="scope">
          <div v-if="scope.row.type == 1" type="success">买入</div>
          <div v-else-if="scope.row.type == 2" type="success">卖出</div>
        </template>
      </el-table-column>
      <el-table-column
        label="交易单价"
        align="center"
        prop="unitPrice"
        width="200"
      ></el-table-column>
      <el-table-column
        label="交易金额"
        align="center"
        prop="worth"
        width="60"
      ></el-table-column>
      <el-table-column
        label="手续费(NYT)"
        align="center"
        prop="subtractQuantity"
        width="120"
      ></el-table-column>

      <el-table-column
        label="发起用户"
        align="center"
        prop="name"
        width="120"
      ></el-table-column>
      <el-table-column
        label="手机号"
        align="center"
        prop="phone"
        width="120"
      ></el-table-column>
      <el-table-column
        label="可用资产余额"
        align="center"
        prop="remainingSum"
        width="120"
      ></el-table-column>
      <el-table-column
        label="待结算资产"
        align="center"
        prop="outstandingBalance"
        width="120"
      ></el-table-column>
      <el-table-column
        label="交易时间"
        align="center"
        prop="createTime"
        width="200"
      ></el-table-column>
    </el-table>
    <el-pagination
      @size-change="handleSizeChange"
      @current-change="handleCurrentChange"
      layout="total, sizes, prev, pager, next, jumper"
      :page-sizes="[10, 20, 50, 100]"
      :current-page="current"
      :page-size="size"
      :total="total"
    ></el-pagination>
  </div>
</template>
<script>
import ExportJsonExcel from "js-export-excel";
import ty from "../../utils/ty";

export default {
  name: "Bill",
  data() {
    return {
      searchForm: {
        endTime: "",
        name: "",
        pageNo: 1,
        pageSize: 10,
        phone: "",
        receivingAddress: "",
        sendAddress: "",
        startTime: "",
        type: "",
      },

      dialogVisible: false,
      delBtlStatu: true,
      tableData: [],
      multipleSelection: [],
      total: 0,
      size: 10,
      current: 1,
      BillDetailsvisible: false,
      //url:ty.apiurl,
      billList: [],
      logistics: "",
      id: "",
      tTime: [],
      dislist: [],
      activeName: "1",
    };
  },
  created() {
    this.getBill();
    this.getdisch();
  },
  methods: {
    getdisch() {
      this.$axios.post("/admin/point/getLadderList").then((res) => {
        this.dislist = res.data;
      });
    },

    getsch() {
      this.current = 1;
      this.getBill();
    },
    getaglin() {
      this.searchForm = {
        endTime: "",
        name: "",
        pageNo: 1,
        pageSize: 10,
        phone: "",
        receivingAddress: "",
        sendAddress: "",
        startTime: "",
        type: "",
      };
      this.current = 1;
      this.getBill();
    },
    toggleSelection(rows) {
      if (rows) {
        rows.forEach((row) => {
          this.$refs.multipleTable.toggleRowSelection(row);
        });
      } else {
        this.$refs.multipleTable.clearSelection();
      }
    },
    handleSelectionChange(val) {
      this.multipleSelection = val;
      this.delBtlStatu = val.length == 0;
    },
    handleSizeChange(val) {
      console.log("6666", val);
      this.size = val;
      this.getBill();
    },
    handleCurrentChange(val) {
      console.log("5555", val);
      this.current = val;
      this.getBill();
    },

    //获取资讯列表
    getBill() {
      if (this.tTime == null) {
        this.searchForm.startTime = "";
        this.searchForm.endTime = "";
      } else {
        this.searchForm.startTime = this.tTime[0];
        this.searchForm.endTime = this.tTime[1];
      }
      this.searchForm.pageNo = this.current;
      this.searchForm.pageSize = this.size;
      this.$axios
        .post("/admin/userPointRecord/getList", this.searchForm)
        .then((res) => {
          this.tableData = res.data.records;
          this.size = res.data.size;
          this.current = res.data.current;
          this.total = res.data.total;
        });
    },
  },
};
</script>

<style scoped>
.el-button {
  padding: 0 10px;
  height: 35px;
  line-height: 35px;
  font-size: 15px;
  margin-right: 10px;
}
</style>
